import { useEffect, useMemo, useState } from "react";
import { BusinessProfileService } from "subModule/src/core/services";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";

/** Fetches business title and builds Shared Business Setup tab breadcrumbs. */
export function useBusinessTabHeader(
  businessId?: string | number | null,
  tabLabelKey?: string,
) {
  const [businessName, setBusinessName] = useState("");

  useEffect(() => {
    if (businessId == null || businessId === "") return;
    BusinessProfileService.getBusinessByID(Number(businessId))
      .then((res: any) => {
        if (res?.success) {
          setBusinessName((res?.data?.title || "").trim());
        }
      })
      .catch((err: any) => {
        console.error("===", err);
      });
  }, [businessId]);

  const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
    const id = businessId != null && businessId !== "" ? String(businessId) : "";
    const crumbs: BreadcrumbItem[] = [
      { labelKey: "businessSetup" },
      { labelKey: "businessDetails", href: "/businesses" },
      {
        labelKey: "Details",
        ...(businessName ? { label: businessName } : {}),
        href: id ? `/business/${id}` : undefined,
      },
    ];
    if (tabLabelKey) {
      crumbs.push({ labelKey: tabLabelKey });
    }
    return crumbs;
  }, [businessId, businessName, tabLabelKey]);

  return { businessName, breadcrumbItems };
}
